import React from 'react'
import PropTypes from 'prop-types'
import { UploadIcon } from 'assets/SVGIcons'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '30px 0 20px',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    fontSize: 14,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: theme.palette.disabled.main,
  },
  errorText: {
    fontSize: 12,
    marginTop: 2,
    textAlign: 'center',
    color: theme.palette.error.main,
    padding: `0 ${theme.spacing(1)}px`,
  },
})

const ImageUploadRejected = ({ classes, errorText }) => (
  <div className={classes.container}>
    <UploadIcon
      style={{
        width: 31,
        height: 38,
        marginLeft: 0,
        marginTop: 0,
      }}
    />
    <Typography className={classes.title} color="primary">
      Drag and drop
    </Typography>
    <Typography className={classes.subtitle}>
      your files here or browse files
    </Typography>
    <Typography className={classes.errorText}>{errorText}</Typography>
  </div>
)

ImageUploadRejected.propTypes = {
  classes: PropTypes.object,
  errorText: PropTypes.string,
}

export default withStyles(styles)(ImageUploadRejected)



// WEBPACK FOOTER //
// ./src/components/atoms/ImageUploadRejected.js